import { boxShadowMixins } from '@styles/mixins';
import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';

export const Container: any = styled.div(({ theme }: ThemeProps) => ({
  cursor: 'pointer',
  color: theme.custom.colors.group4.base,
  transition: `color ${theme.custom.transitions.default}`,
  '&:hover': {
    '.global-hover': {
      transition: `color ${theme.custom.transitions.default}`,
      color: theme.custom.colors.group1.base
    }
  }
}));

export const ImageCrossfadeContainer = styled.div(({ theme }: ThemeProps) => ({
  width: '100%',
  boxShadow: boxShadowMixins(theme.custom.colors.group10.base).light,
  marginBottom: 10
}));

export const DestinationLabel = styled.span(({ theme }: ThemeProps) => ({
  display: 'block',
  textTransform: 'uppercase',
  color: theme.custom.colors.group4.light,
  ...(theme.custom.typography.labels.attribute as any)
}));

export const HotelNameLabel = styled.span(({ theme }: ThemeProps) => ({
  display: 'block',
  marginTop: theme.custom.spacing.xSmall,
  ...(theme.custom.typography.h5 as any),
  fontWeight: 500
}));

export const PriceContainer = styled.div({
  display: 'flex',
  alignItems: 'center'
});

export const PriceLabelDefault = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any)
}));

export const AttributesContainer = styled.div({
  display: 'flex',
  flexWrap: 'wrap'
});

export const Attribute = styled.div(({ theme }: ThemeProps) => ({
  paddingRight: theme.custom.spacing.xSmall,
  marginTop: theme.custom.spacing.xSmall,

  ['i']: {
    color: theme.custom.colors.group4.light
  }
}));

export const AttributeLabel = styled.span(({ theme }: ThemeProps) => ({
  paddingLeft: theme.custom.spacing.xSmall,
  whiteSpace: 'nowrap',
  ...(theme.custom.typography.labels.default as any),
  color: theme.custom.colors.group4.light,
  fontWeight: 500
}));

export const RatingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: 10,
  justifyContent: 'flex-start'
});

export const tripAdvisorRating = css({
  maxWidth: '40%'
});

export const PerPerson = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  textTransform: 'none',
  marginLeft: 2
}));
